__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "3.28.1", () => (__webpack_require__.e(6262).then(() => (() => (__webpack_require__(6262))))));
			register("@azure/msal-react", "2.2.0", () => (Promise.all([__webpack_require__.e(1806), __webpack_require__.e(3240)]).then(() => (() => (__webpack_require__(1806))))));
			register("@datadog/browser-rum", "5.35.1", () => (__webpack_require__.e(5078).then(() => (() => (__webpack_require__(5078))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(9240), __webpack_require__.e(4158)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.0", () => (Promise.all([__webpack_require__.e(7835), __webpack_require__.e(1479)]).then(() => (() => (__webpack_require__(1479))))));
			register("@mui/icons-material", "5.17.1", () => (Promise.all([__webpack_require__.e(9240), __webpack_require__.e(1611), __webpack_require__.e(561), __webpack_require__.e(4789), __webpack_require__.e(7835), __webpack_require__.e(2339)]).then(() => (() => (__webpack_require__(4789))))));
			register("@mui/material", "5.17.1", () => (Promise.all([__webpack_require__.e(9240), __webpack_require__.e(1611), __webpack_require__.e(6886), __webpack_require__.e(561), __webpack_require__.e(9957), __webpack_require__.e(1394), __webpack_require__.e(7835), __webpack_require__.e(2339), __webpack_require__.e(1086)]).then(() => (() => (__webpack_require__(9957))))));
			register("@mui/system", "5.17.1", () => (Promise.all([__webpack_require__.e(9240), __webpack_require__.e(1611), __webpack_require__.e(6886), __webpack_require__.e(6590), __webpack_require__.e(7835), __webpack_require__.e(2339), __webpack_require__.e(3324)]).then(() => (() => (__webpack_require__(6590))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(8067), __webpack_require__.e(8713)]).then(() => (() => (__webpack_require__(8713))))));
			register("axios", "1.7.4", () => (__webpack_require__.e(1914).then(() => (() => (__webpack_require__(1914))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-error-boundary", "4.1.2", () => (__webpack_require__.e(7665).then(() => (() => (__webpack_require__(7665))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(1225), __webpack_require__.e(7336)]).then(() => (() => (__webpack_require__(3606))))));
			register("react-router-dom", "6.26.2", () => (() => (__webpack_require__(2648))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("redux-logger", "3.0.6", () => (__webpack_require__.e(9448).then(() => (() => (__webpack_require__(9448))))));
			register("redux-persist", "6.0.0", () => (Promise.all([__webpack_require__.e(8067), __webpack_require__.e(1385)]).then(() => (() => (__webpack_require__(1385))))));
			register("redux-saga", "1.3.0", () => (Promise.all([__webpack_require__.e(7701), __webpack_require__.e(8424), __webpack_require__.e(4955)]).then(() => (() => (__webpack_require__(7701))))));
			initExternal(4189);
			initExternal(6977);
			initExternal(3480);
			initExternal(8968);
			initExternal(703);
			initExternal(9844);
			initExternal(9631);
			initExternal(6422);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};